import React, { useRef } from 'react';
import { ArrowRight, Sparkles, X } from 'lucide-react';
import './PreviewModal.css';
import Modal from './Modal';

const PreviewModal = ({ onClose, onPrimary }) => {
  const primaryActionRef = useRef(null);

  return (
    <Modal
      onClose={onClose}
      labelledBy="preview-modal-title"
      describedBy="preview-modal-desc"
      initialFocusRef={primaryActionRef}
    >
      <div className="modal-topline">
        <span className="modal-kicker">
          <Sparkles size={13} strokeWidth={1.8} aria-hidden="true" />
          Aayush&rsquo;s digital twin
        </span>
        <button className="modal-close" type="button" onClick={onClose} aria-label="Close welcome dialog">
          <X size={17} strokeWidth={1.7} aria-hidden="true" />
        </button>
      </div>

      <h2 id="preview-modal-title" className="modal-headline">
        Ask the version that knows the work.
      </h2>
      <p id="preview-modal-desc" className="modal-subheadline">
        Projects, experience, ideas&mdash;or whether Aayush is the right person to build with.
      </p>

      <div className="modal-actions">
        <button ref={primaryActionRef} className="modal-btn primary" onClick={onPrimary}>
          Start a conversation
          <ArrowRight size={17} strokeWidth={1.8} aria-hidden="true" />
        </button>
        <button className="modal-btn secondary" type="button" onClick={onClose}>
          Browse on my own
        </button>
      </div>

      <p className="modal-note">No sign-up. Just ask.</p>
    </Modal>
  );
};

export default PreviewModal;
